import React from 'react';

import IconVK from '../Icons/IconVK';
//import IconFB from '../Icons/IconFB';
import IconTW from '../Icons/IconTW';
//import IconIG from '../Icons/IconIG';
import IconTG from '../Icons/IconTG';
import IconTT from '../Icons/IconTT';
import IconUT from '../Icons/IconUT';
import IconWhatsApp from '../Icons/IconWhatsApp';

import './styles/socialLinks.scss';

// Попытался сделать универсальный компонент для соцсетей.
// Без переданных параметров выводит все соцсети с дефолтными ссылками
// Можно передать отдельно список соцсетей props.items, выведутся с дефолтными ссылками
// Либо передать props.items и props.links, если нужен кастомный набор соцсетей и ссылок

const defaultLinks = {
  vk: 'https://vk.com/fitronrostov',
  fb: 'https://www.facebook.com/fitronrostov',
  tw: '#',
  ig: 'https://www.instagram.com/fitron_club/',
  tg: 'https://t.me/fitron_club',
  tt: 'https://vm.tiktok.com/ZSddyFSoW/',
  yt: 'https://www.youtube.com/channel/UC_Q0C5yjr7i19ulPQ5x2oIQ',
  wa: '#'
};

// https://www.instagram.com/fitron_club/
// https://www.facebook.com/fitronrostov
// https://vk.com/fitronrostov
// https://www.youtube.com/channel/UC_Q0C5yjr7i19ulPQ5x2oIQ

const defaultItems = ['vk', 'tg', 'yt'];

const SocialLinks = (props) => {
  const items = props.items || defaultItems;
  const links = props.links || defaultLinks;

  return (
    <ul className={`socialLinks ${props.type || ''}`}>
      {items.map((item, index) => {
        switch (item) {
          case 'vk':
            return (
              <li className="socialLinks__item _vk" key={index}>
                <a href={links.vk} aria-label="vk" rel="nofollow noopener" target="_blank">
                  <IconVK />
                </a>
              </li>
            );
          case 'tt':
            return (
              <li className="socialLinks__item _tt" key={index}>
                <a href={links.tt} aria-label="tik tok" rel="nofollow noopener" target="_blank">
                  <IconTT />
                </a>
              </li>
            );
          case 'tw':
            return (
              <li className="socialLinks__item _tw" key={index}>
                <a href={links.tw} aria-label="tw" rel="nofollow noopener" target="_blank">
                  <IconTW />
                </a>
              </li>
            );
          case 'tg':
            return (
              <li className="socialLinks__item _tg" key={index}>
                <a href={links.tg} aria-label="telegram" rel="nofollow noopener" target="_blank">
                  <IconTG />
                </a>
              </li>
            );
          case 'yt':
            return (
              <li className="socialLinks__item _yt" key={index}>
                <a href={links.yt} aria-label="youtube" rel="nofollow noopener" target="_blank">
                  <IconUT />
                </a>
              </li>
            );
          case 'wa':
            return (
              <li className="socialLinks__item _wa" key={index}>
                <a href={links.wa} aria-label="wa" rel="nofollow noopener" target="_blank">
                  <IconWhatsApp />
                </a>
              </li>
            );
          default:
            return null;
        }
      })}
    </ul>
  );
};

export default SocialLinks;
